// extracted by mini-css-extract-plugin
export default {"container":"warn-spi-chart_container__bkHyt"};